import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/critical-infrastructure/page.tsx");
